import clsx from 'clsx';
import React, {useMemo} from 'react';
import translate from '@/utils/translate';
import {BaseFilterOption} from '@/types/models/creator-crm/filter';
import CheckboxLabel from '@/components/checkbox-label';
import styles from './MultiSelectionOptionsList.module.scss';

interface MultiSelectionOptionsListProps {
  options: BaseFilterOption[];
  selectedOptions?: BaseFilterOption[];
  onChange: (option: BaseFilterOption) => void;
  scrollable?: boolean;
}

function MultiSelectionOptionsList(props: MultiSelectionOptionsListProps) {
  const {options, selectedOptions = [], onChange, scrollable = true} = props;

  const selectedOptionsMap = useMemo(
    () =>
      selectedOptions.reduce(
        (acc: {[key: string]: boolean}, curr: BaseFilterOption) => {
          acc[curr.id] = true;
          return acc;
        },
        {}
      ),
    [selectedOptions]
  );

  return (
    <div className={clsx(styles.container, !scrollable && styles.fullHeight)}>
      {options.map((option) => (
        <div key={option.id} className={styles.optionRow}>
          <CheckboxLabel
            checked={!!selectedOptionsMap[option.id]}
            onChange={() => onChange(option)}
            label={translate(option.localeLabelKey)}
          />
        </div>
      ))}
    </div>
  );
}

export default MultiSelectionOptionsList;
